<template>
  <div class="wrap">
    <div class="boxCard">
      <el-card class="box-card" :body-style="{padding: '0'}">
        <div slot="header" class="clearfix">
          <span>活动订单</span>
        </div>
        <el-form :inline="true" :model="queryParams" ref="queryParams" class="demo-form-inline">
          <el-form-item label="用户名称" prop="memberName">
            <el-input v-model="queryParams.memberName"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="sourceType">
            <el-select v-model="queryParams.sourceType" placeholder="请选择">
              <el-option label="购设备送VIP" :value="1"></el-option>
              <el-option label="正价购买" :value="2"></el-option>
              <el-option label="员工转入" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源药企" prop="sourceEnterprise">
            <el-input v-model="queryParams.sourceEnterprise"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetQuery">查询</el-button>
            <el-button @click="resetForm('queryParams')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="boxCard">
      <el-card class="box-card" :body-style="{padding: '0'}">
        <div slot="header"> 
          <span class="tabTitle">订单列表</span>
          <!-- <el-button type="primary" @click="addMember">新增会员</el-button> -->
        </div>
        <el-table :data="tableData" show-header border style="width: 100%">
          <el-table-column type="index" align="center" label="序号" />
          <el-table-column prop="memberName" align="center" label="用户名称" />
          <el-table-column prop="phoneNum" align="center" label="手机号" />
          <el-table-column prop="vipServicePrice" align="center" label="购买价格" />
          <el-table-column prop="sourceType" label="类型" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.sourceType == 1">购设备送VIP</el-tag>
              <el-tag v-if="scope.row.sourceType == 2" type="success">正价购买</el-tag>
              <el-tag v-if="scope.row.sourceType == 3" type="danger">员工转入</el-tag>
              <el-tag v-if="scope.row.sourceType == 4" type="danger">365暖心健康包赠送</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="payTime" align="center" label="支付时间" />
          <el-table-column prop="orderStatus" label="支付状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.orderStatus == 1">待支付</span>
              <el-tag v-if="scope.row.orderStatus == 6">已完成</el-tag>
              <el-tag type="success" v-if="scope.row.orderStatus == 2">已支付</el-tag>
              <el-tag type="info" v-if="scope.row.orderStatus == 4">已退款</el-tag>
              <el-tag type="warning" v-if="scope.row.orderStatus == 5">已关闭</el-tag>
              <el-tag type="danger" v-if="scope.row.orderStatus == 3">退款中</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sourceEnterprise" label="来源药企" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="detail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="queryParams.pageNum" :page-size="queryParams.pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
      </el-card>
    </div>

    <!-- 详情侧边弹出框 -->
    <el-drawer :visible.sync="showDetail" :with-header="false" size="45%">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>问诊详情</span>
          <i class="el-icon-close" style="float: right;font-size: 24px" @click="showDetail = false"></i>
        </div>
        <div class="content">
          <div class="item">
            <p>会员姓名：</p>
            <p>{{userDetail.memberName|| "--"}}</p>
          </div>
          <div class="item">
            <p>订单编号：</p>
            <p>{{userDetail.orderNum || '--'}}</p>
          </div>
          <div class="item">
            <p>活动名称：</p>
            <p>{{userDetail.vipServiceName || '--'}}</p>
          </div>
          <div class="item">
            <p>活动原价：</p>
            <p>{{userDetail.originalPrice || '0'}}元</p>
          </div>
          <div class="item">
            <p>实付价格：</p>
            <p>{{userDetail.vipServicePrice || '0'}}元</p>
          </div>
          <div class="item">
            <p>抵扣价格：</p>
            <p>{{userDetail.deductionPrice || '0'}}元</p>
          </div>
          <div class="item">
            <p>以旧换新：</p>
            <p>{{userDetail.tradeIn ? '是' : '否'}}</p>
          </div>
          <div class="item">
            <p>支付方式：</p>
            <p>{{userDetail.payWay == 1 ? '微信支付' : '其他'}}</p>
          </div>
          <div class="item">
            <p>支付状态：</p>
            <p>{{getOrderStatusStr(userDetail.orderStatus)}}</p>
          </div>
          <div class="item">
            <p>转化来源：</p>
            <p>
              <el-tag v-if="userDetail.sourceType == 1">购设备送VIP</el-tag>
              <el-tag v-if="userDetail.sourceType == 2" type="success">正价购买</el-tag>
              <el-tag v-if="userDetail.sourceType == 3" type="danger">员工转入</el-tag>
            </p>
          </div>
          <div class="item">
            <p>归属门店：</p>
            <p>{{userDetail.storeName || '--'}}</p>
          </div>
          <!-- <div class="item">
            <p>到期时间：</p>
            <p>{{userDetail.serviceExpireTime || '--'}}</p>
          </div> -->
        </div>
      </el-card>
    </el-drawer>
    <my-from-dialog :isShow="isShowDiaFlag" :title="'订单详情'" @cancel="closePup" @ok="closePup('ok')" @closeCallBack="closePup" :isFullscreen="true" :scrollHeight="'800px'" :dialogWidth="'500px'" :okBtnText="'保 存'" :cancelBtn="true" :okBtn="false">
      <template slot="froms">
        <el-divider content-position="left" class="divider">订单信息<el-tag>状态：{{formatOrderStatus(orderDetail.orderStatus)}}</el-tag>
          <el-tag type="danger">订单金额：¥{{orderDetail.orderPrice && orderDetail.orderPrice.toFixed(2)}}</el-tag>
          <el-tag type="danger">订单数量：{{orderDetail.orderCount}}</el-tag>
        </el-divider>
        <el-card class="card" v-for="(item, i) in shoppingList" :key="item.id">
          <div class="card_content">
            <div class="img">
              <img :src="item.buyCommodityImg" alt="">
            </div>
            <div class="txt">
              <p>{{item.buyCommodityName}}</p>
              <p>¥{{setTofixed(item.buyCommodityPrice)}}</p>
            </div>
            <div class="num">数量：{{setTofixed(item.buyCommodityNum)}}</div>
          </div>
        </el-card>
        <!-- <div class="order_text">
              <p>订单金额：<el-tag type="danger">¥899.00</el-tag></p>
              <p>订单数量：<el-tag type="danger">89</el-tag></p>
            </div> -->
        <el-divider content-position="left" class="divider">收货信息</el-divider>
        <div v-if="orderDetail.pickWay == 1">

          <el-form label-width="120px" label-position="right">
            <el-row class="label_width">
              <el-col :span="12">
                <el-form-item label="取货方式：">{{orderDetail.pickWay == 1 ? '自提' : '快递'}}</el-form-item>
              </el-col>
            </el-row>
            <el-row class="label_width">
              <el-col :span="12">
                <el-form-item label="自提门店：">{{orderDetail.storeName}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="门店地址：">{{orderDetail.address}}</el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="门店电话：">{{orderDetail.callNum}}</el-form-item>
            <!-- <el-form-item label="备注：">123412321</el-form-item> -->
          </el-form>

        </div>
        <div v-if="orderDetail.pickWay == 2">

          <el-form label-width="120px" label-position="right">
            <el-row class="label_width">
              <el-col :span="12">
                <el-form-item label="取货方式：">{{orderDetail.pickWay == 1 ? '自提' : '快递'}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收货人">{{orderDetail.consigneeName}}</el-form-item>
              </el-col>
            </el-row>
            <el-row class="label_width">
              <el-col :span="12">
                <el-form-item label="收货人电话：">{{orderDetail.callNum}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收货地址：">{{orderDetail.address}}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-divider content-position="left" class="divider">物流信息</el-divider>
          <el-form label-width="120px" label-position="right">
            <el-row class="label_width">
              <el-col :span="12">
                <el-form-item label="物流公司：">{{orderDetail.logisticsCompany}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物流单号：">{{orderDetail.logisticsNum}}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </template>
    </my-from-dialog>
  </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog';
import { objDeepCopy, resDecPoint } from '@/utils/index';
let self = null;
export default {
  components: { myFromDialog },
  computed: {},
  watch: {},
  created() {
    this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
    console.log('药企', this.loginData)
    this.orderList();
    self = this;
  },
  data() {
    return {
      isShowDiaFlag: false,
      showDetail: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        memberName: '',
        sourceType: '',
        sourceEnterprise: ''
      },
      userDetail: {},
      orderDetail: {},
      shoppingList: [],
      tableData: [], // 列表数据
      // ================================= 分页 -s
      totalCount: 0,
      // ================================= 分页 -e
    }
  },
  methods: {
    getOrderStatusStr(type) {
      return {
        '1': '待支付',
        '2': '已支付',
        '3': '退款中',
        '4': '已退款',
        '5': '已关闭',
        '6': '已完成'
      }[type] || '--';
    },
    orderList() {
      if (localStorage.getItem('enterpriseInfo') != 'undefined') {
        if (localStorage.getItem('enterpriseType') == '1') {
          this.queryParams.enterpriseId = JSON.parse(localStorage.getItem('loginData')).enterpriseId;
        } else {
          this.queryParams.storeId = JSON.parse(localStorage.getItem('loginData')).storeId;
        }
      }
      this.$https.post('system/vipService/list', this.queryParams).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.totalCount = res.data.total;
        }
      })
      // this.queryParams.
    },
    resetQuery() { // 查询
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.orderList();
    },
    // 格式化订单状态
    formatOrderStatus(type) {
      return {
        1: '待支付',
        2: '已支付',
        3: '退款中',
        4: '已退款',
        5: '已关闭',
        6: '已完成',
        7: '已发货'
      }[type]
    },
    resetForm(formName) { // 表单重置
      this.$refs[formName].resetFields();
      this.orderList();
      // this.getMemberList();
    },
    // 两位小数
    setTofixed(num) {
      return num.toFixed(2)
    },
    closePup(state) { // 关闭弹窗
      this.isShowDiaFlag = false;
    },
    // =================================================================================== 分页 -s
    barSizeChange(val) { // 当前显示条数
      this.pageSize = val;
      this.orderList();
    },
    barCurrentChange(val) { // 当前页
      this.pageNum = val;
      this.orderList();
    },
    // =================================================================================== 分页 -e
    detail(row) { // 详情
      console.log(row)
      this.showDetail = true;
      this.userDetail = JSON.parse(JSON.stringify(row));
      // let param = {
      //   orderNum: this.orderDetail.orderNum,
      //
      // }
      // this.$https.get('system/activityOrder/getActivityOrderByOrderNum', param).then(res => {
      //   if (res.code == 200) {
      //     this.shoppingList = res.data;
      //   }
      // })
    },
    pickUp(row) {
      this.$alert(`请确认会员“${row.memberName}”的订单已到店取货`, '提示', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            this.$https.get('system/activityOrder/updateActivityOrderStatus', { id: row.id }).then(res => {
              if (res.code == 200) {
                this.orderList();
                this.$message({
                  type: 'success',
                  message: res.msg
                });
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      });
    }
  },
}
</script>

<style lang="less" scoped>
.boxCard {
    margin-bottom: 20px;
}
.tabTitle {
    color: #333;
    font-size: 15px;
    font-weight: bold;
    margin-right: 30px;
}
.divider {
    .el-divider__text {
        font-weight: bold;
        font-size: 16px;
        .el-tag {
            margin-left: 30px;
        }
    }
}
.label_width {
    width: 1000px;
}
.card {
    margin-bottom: 10px;
    width: 350px;
    font-size: 16px;
    font-weight: bold;
    .card_content {
        display: flex;
        align-items: center;
        .img {
            width: 80px;
            height: 80px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .txt {
            flex: 1;
            margin-left: 30px;
            p {
                margin-bottom: 20px;
            }
        }
    }
}
.order_text {
    margin: 40px;
    font-size: 15px;
    p {
        display: inline-block;
        margin-right: 20px;
    }
}
.content {
  // padding: 10px 20px;
  width: 100%;
  overflow-y: hidden;
  // width: calc(100% - 40px);
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 50%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333333;
        margin-bottom: 20px;
    p:first-child {
      width: 90px;
      word-break: keep-all;
    }
    p:last-child {
      flex: 1;
      word-break: break-all;
    }
  }
  .blue {
    color: #1890ff;
    cursor: pointer;
  }
  .item1 {
    display: flex;
    font-size: 14px;
    /deep/ .el-image {
      width: 50px;
      vertical-align: middle;
      margin-right: 10px;
    }
    .name,
    .detail,
    .money,
    .totalMoney {
      color: #666666;
      margin-right: 20px;
    }
    .f1 {
      width: 90px;
    }
  }
}
</style>
